import React from "react";
import { usePrice } from "@/lib/price";

const baseStats = [
  { value: "9", label: "TOOLS" },
  { value: "4.9★", label: "MEMBER RATING" },
  { value: "18K", label: "ATS BOARDS · LIVE" },
];

export default function ProofBar() {
  const { price } = usePrice();
  const stats = [...baseStats, { value: price, label: "ONE-TIME · LIFETIME" }];
  return (
    <section
      data-testid="proofbar"
      className="border-b-4 border-[#0a0a0a] bg-[#FDFBF7]"
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-2 md:grid-cols-4 divide-x-0 md:divide-x-4 divide-[#0a0a0a]">
        {stats.map((s, i) => (
          <div
            key={s.label}
            data-testid={`proofbar-stat-${i}`}
            className={`p-6 md:p-10 text-center reveal ${i < 2 ? "border-b-4 md:border-b-0 border-[#0a0a0a]" : ""} ${i % 2 === 0 ? "border-r-4 md:border-r-0 border-[#0a0a0a]" : ""}`}
          >
            <div className="font-display text-4xl md:text-6xl">{s.value}</div>
            <div className="font-accent text-xs md:text-sm mt-2 text-[#0a0a0a]/60">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
